import { MaintenanceService as MaintenanceServiceBC } from 'gw-capability-bcmaintenance';
import { MaintenanceService as MaintenanceServiceCC } from 'gw-capability-ccmaintenance';
import { MaintenanceService as MaintenanceServiceCM } from 'gw-capability-cmmaintenance';
import { MaintenanceService as MaintenanceServicePC } from 'gw-capability-pcmaintenance';
import appConfig from 'app-config';
import { getConfigValue } from '@jutro/config';

/**
 * A function to call the backend maintenance services to check if an application is in maintenance mode. If any of
 * the services return an error, the application is considered to be in maintenance mode. Only services that are enabled
 * in the capabilitiesConfig of the config.json5 will be called.
 *
 * @function checkMaintenanceMode
 * @memberof module:gw-maintenance-js
 * @returns {Promise} - A promise that resolves to true if the application is in maintenance mode, false otherwise.
 */

const maintenanceRedirectUrl = getConfigValue('MAINTENANCE_REDIRECT_URL', appConfig.enterpriseMaintenanceURL);

export const checkMaintenanceMode = () =>
    Promise.all([
        MaintenanceServicePC?.isInMaintenanceMode(),
        MaintenanceServiceBC?.isInMaintenanceMode(),
        MaintenanceServiceCC?.isInMaintenanceMode(),
        MaintenanceServiceCM?.isInMaintenanceMode()
    ])
        .then(responses => {
            // If any service returns true, show the maintenance page
            if (responses.some(response => response === true)) {
                Promise.resolve(true);
                window.location.href = maintenanceRedirectUrl;
            }

            return Promise.resolve(false);
        })
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .catch(e => {
           
           Promise.resolve(true);
            window.location.href = maintenanceRedirectUrl;
        });
